<template>
  <v-flex
    v-if="actions.length > 0"
    class="mass-actions-container pa-0"
  >
    <v-select
      v-model="selectedAction"
      :items="actions"
      :label="$t('Mass Action')"
      item-value="code"
      item-text="label"
    />
    <v-btn
      :disabled="!selectedAction"
      color="primary"
      small
      @click="submitAction"
    >
      {{ $t('Submit') }}
    </v-btn>
  </v-flex>
</template>

<script>
export default {
  name: 'MassActionSelect',
  props: {
    actions: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      selectedAction: null
    }
  },

  methods: {
    submitAction () {
      this.$emit('action-selected', this.selectedAction)
    }
  }
}
</script>

<style lang="stylus">
  .mass-actions-container {
    width: auto;
    display: inline-block;

    .v-select {
      display: inline-block;
    }
  }
</style>
